<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template v-slot:progress>
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>
      <v-card-text class="pb-0">
        <div class="text-h6 font-weight-black">Pessoas com Deficiência (PcD)</div>
      </v-card-text>
      <div class="content-flex">
        <!-- Gráfico no lado esquerdo (menor) -->
        <div style="flex: 0.7; height: 100%; position: relative; margin-top: 5px">
          <apexchart height="55%" width="100%" :options="chartOptions" :series="series" />
        </div>

        <!-- Legendas no lado direito (maior) -->
        <div style="flex: 1; padding: 14px; overflow-y: auto; height: 100px">
          <div class="legend-container">
            <div v-for="(label, index) in chartOptions.labels" :key="index" class="legend-item">
              <span class="legend-color" :style="{ backgroundColor: getColor(index) }"></span>
              <span class="legend-text">{{ label }}: {{ series[index] }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ProfessorDeficientesCard",
  mounted() {
    this.getDeficientes();
  },
  data() {
    return {
      loading: true,
      series: [],
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#775DD0",
        "#FF4560",
        "#546E7A",
        "#26a69a",
        "#D10CE8",
        "#FF6D00",
        "#7f7f7f",
        "#aec7e8",
      ],
      chartOptions: {
        chart: {
          type: "donut",
        },
        colors: [],
        legend: {
          show: false,
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "55%",
            },
          },
        },
      },
    };
  },
  methods: {
    getColor(index) {
      return this.colors[index % this.colors.length];
    },
    async getDeficientes() {
      try {
        const response = await this.$services.professoresService.deficientes();
        const data = Object.entries(response.deficientes);

        const categories = [];
        const seriesData = [];
        const chartColors = [];

        data.forEach(([category, value], index) => {
          categories.push(category);
          seriesData.push(parseInt(value, 10));
          chartColors.push(this.colors[index % this.colors.length]);
        });

        this.series = seriesData;
        this.chartOptions = {
          ...this.chartOptions,
          labels: categories,
          colors: chartColors,
        };
      } catch (error) {
        this.series = [0];
        this.chartOptions.labels = ["Erro"];
        this.chartOptions.colors = [this.colors[0]];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.legend-container {
  margin-top: 10px;
  max-height: 100px;
  overflow-y: auto;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-right: 8px;
}

.legend-text {
  font-size: 0.8rem;
}
.content-flex {
  display: flex;
  height: 100%;
}

/* Ajustes responsivos */
@media (max-width: 600px) {
  div[style*="display: flex"] {
    flex-direction: column;
  }

  .legend-container {
    max-height: none;
  }
}
</style>
